
import crumbs from '@/breadcrumbs.json'
export default {
  props: {
    breadcrumb: {
      type: String,
      required: true,
    },
    /** Optional parent items to show before breadcrumb-derived items (e.g. [{ slug: 'blog', title: 'Blog Yazılarımız' }]) */
    prependItems: {
      type: Array,
      default: () => [],
    },
    /** CMS SEO breadcrumbList override: middle trail only [{ text, url }] — home + current page are auto-added */
    breadcrumbList: {
      type: Array,
      default: null,
    },
  },
  inject: {
    seoBreadcrumbList: {
      default: null,
    },
    seoBreadcrumbPage: {
      default: null,
    },
  },
  data() {
    return {
      array: [],
    }
  },

  async asyncData({ params }) {
    // Assuming you want to generate breadcrumbs based on some route parameter
    const breadcrumbPath = params.slug || ''; // Adjust according to your routing logic
    const breadcrumbs = crumbs.filter(crumb => breadcrumbPath.startsWith(crumb.slug)).slice(-5); // Example filtering logic

    return { breadcrumbs };
  },

  computed: {
    resolvedCmsBreadcrumbList() {
      if (Array.isArray(this.breadcrumbList) && this.breadcrumbList.length > 0) {
        return this.breadcrumbList
      }
      const injected =
        typeof this.seoBreadcrumbList === 'function'
          ? this.seoBreadcrumbList()
          : this.seoBreadcrumbList
      if (Array.isArray(injected) && injected.length > 0) {
        return injected
      }
      return null
    },
    currentPageItem() {
      const slug = this.normalizeUrl(this.breadcrumb)
      if (!slug) return null
      const fromJson = this.findBreadcrumb(slug)
      if (fromJson) return fromJson
      const page =
        typeof this.seoBreadcrumbPage === 'function'
          ? this.seoBreadcrumbPage()
          : this.seoBreadcrumbPage
      const title = (page && page.title) || slug
      return { title, slug }
    },
    breadcrumbs() {
      const cmsList = this.resolvedCmsBreadcrumbList
      if (cmsList) {
        const middle = this.mapCmsBreadcrumbList(cmsList)
        const current = this.currentPageItem
        const trail = current
          ? [...middle.filter((item) => item.slug !== current.slug), current]
          : middle
        if (trail.length > 0) return trail
      }

      if (!this.breadcrumb || this.breadcrumb === undefined || this.breadcrumb.length === 0) {
        return;
      }
      let slugs = [];
      if(this.breadcrumb.indexOf('/') ==  -1){
        // remove / from breadcrumb
        this.breadcrumb = this.breadcrumb.replace(/\//g, '');
        slugs = [this.breadcrumb]
      }else{
        slugs = this.breadcrumb.split('/')
      }
      
      let breadcrumbs = []

      for (let i = 0; i < slugs.length; i++) {
        const slug = slugs.slice(0, i + 1).join('/')
        const breadcrumb = this.findBreadcrumb(slug)
        if (breadcrumb) {
          breadcrumbs.push(breadcrumb)
        }
      }

      const prepend = (this.prependItems || []).filter(
        (item) => item && item.slug != null && item.title != null
      )
      return prepend.length ? [...prepend, ...breadcrumbs] : breadcrumbs

    },
    
      jsonLD() {
        if (this.breadcrumbs !== undefined) {
          if (this.breadcrumbs.length > 0) {
        let itemListElement = [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Anasayfa",
            "item": this.absoluteUrl('')
          },
          ...this.breadcrumbs.map((breadcrumb, index) => {
            return {
          "@type": "ListItem",
          "position": index + 2, // Adjust position to account for homepage
          "name": this.breadcrumbPlainTitle(breadcrumb.title),
          "item": this.absoluteUrl(breadcrumb.slug)
            }
          })
        ];

        return {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": itemListElement
        };
          }
        }
      }
     //*/

  },
  
   head() {
    let headObject = {
    script: []
  };

    if (this.jsonLD && this.jsonLD.itemListElement && this.jsonLD.itemListElement.length > 0) {
      headObject.script.push({
        type: 'application/ld+json',
        json: this.jsonLD
      });
    }

    return headObject;
  
   },
  methods: {
    absoluteUrl(slug) {
      const baseUrl = (process.env.BASE_URL || 'https://www.mikro.com.tr').replace(/\/$/, '')
      const path = this.normalizeUrl(slug)
      return path ? `${baseUrl}/${path}/` : `${baseUrl}/`
    },
    normalizeUrl(url) {
      if (!url || typeof url !== 'string') return ''
      let path = url.trim()
      if (/^https?:\/\//i.test(path)) {
        try {
          path = new URL(path).pathname
        } catch (e) {
          // keep path as-is if URL parsing fails
        }
      }
      return path.replace(/^\/+|\/+$/g, '')
    },
    isHomeBreadcrumb(item) {
      if (!item) return true
      const raw = item.url
      if (raw == null || String(raw).trim() === '' || String(raw).trim() === '/') return true
      return this.normalizeUrl(raw) === ''
    },
    isCurrentPageBreadcrumb(item) {
      const currentSlug = this.normalizeUrl(this.breadcrumb)
      if (!currentSlug || !item) return false
      return this.normalizeUrl(item.url) === currentSlug
    },
    mapCmsBreadcrumbList(list) {
      if (!Array.isArray(list)) return []
      return list
        .filter(
          (item) =>
            item &&
            item.text != null &&
            String(item.text).trim() !== '' &&
            !this.isHomeBreadcrumb(item) &&
            !this.isCurrentPageBreadcrumb(item)
        )
        .map((item) => ({
          title: item.text,
          slug: this.normalizeUrl(item.url),
        }))
        .filter((item) => item.slug)
    },
    itemLabel(label) {
      if (!label || typeof label !== 'string') return label
      if (label.includes('*')) {
        label = label.replace('*', '')
        return `${label} &nbsp;<span class="new-menu">yeni</span>`
      }
      return label
    },
    breadcrumbPlainTitle(title) {
      if (!title || typeof title !== 'string') return title
      if (title.includes('*')) {
        return `${title.replace('*', '')} yeni`
      }
      return title
    },
    findBreadcrumb(slug) {
      const breadcrumb = crumbs.find((breadcrumb) => breadcrumb.slug === slug)
      return breadcrumb
        ? { title: breadcrumb.title, slug: breadcrumb.slug }
        : null
    },
  },
}
